import {
  CommonContext,
  EmployeeApi,
  NavbarLink,
  NavbarTemplate,
  PageCircularProgress,
  PortalModeType,
  PortalSwitchButton,
  ReducerContext,
  useUser,
} from '@abdoo/common';
import { useMsal } from '@azure/msal-react';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import HistoryIcon from '@mui/icons-material/History';
import HomeIcon from '@mui/icons-material/Home';
import React, { useCallback, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { AppContext } from '../App/App';
import { environment } from '../environment';

export const Navbar = () => {
  const { accounts } = useMsal();
  const { pageTitle } = useContext(AppContext);
  const { userSettingsState } = useContext(ReducerContext);
  const history = useHistory();
  const [closeDrawer, setCloseDrawer] = useState(false);
  const { isOnline } = useContext(CommonContext);

  const { switchMode } = useUser(EmployeeApi);

  const onSwitchModeSuccess = () => {
    window.location.href = `${environment.managerFrontendUrl ?? ''}?modeSwitch=true`;
  };

  const switchToManagerMode = useCallback(() => {
    switchMode().mutation(PortalModeType.Manager, onSwitchModeSuccess);
  }, [switchMode]);

  const goToStartManaging = useCallback(() => {
    setCloseDrawer(true);
    history.push('/startManaging');
  }, [history]);

  if (accounts.length === 0) {
    return null;
  }

  const switchPortalButton = (
    <PortalSwitchButton
      onClick={userSettingsState.isManager ? switchToManagerMode : goToStartManaging}
      buttonKey="EmployeeMode"
      text="Employee mode"
      switchToText={userSettingsState.isManager ? 'Manager mode' : 'Start managing'}
      isManager={userSettingsState.isManager}
    ></PortalSwitchButton>
  );

  const customNavbarLinks = (
    <>
      <NavbarLink linkTo="/home" linkKey="home" text="Home">
        <HomeIcon />
      </NavbarLink>
      <NavbarLink linkTo="/calendar" linkKey="calendar" text="Calendar">
        <CalendarTodayIcon />
      </NavbarLink>
      <NavbarLink
        offlineMode={!isOnline}
        linkTo="/history"
        linkKey="history"
        text="Request history"
      >
        <HistoryIcon />
      </NavbarLink>
    </>
  );

  return (
    <>
      {switchMode().isLoading ? (
        <PageCircularProgress />
      ) : (
        <NavbarTemplate
          pageTitle={pageTitle}
          customNavbarLinks={customNavbarLinks}
          switchPortalButton={switchPortalButton}
          settingsPageLink="/settings"
          userId={userSettingsState.userId}
          closeDrawerExternally={closeDrawer}
          setCloseDrawerExternally={setCloseDrawer}
          userEmail={userSettingsState.userName}
        ></NavbarTemplate>
      )}
    </>
  );
};
